import {
  Box,
  Button,
  Card,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
  useToken,
} from "@chakra-ui/react";
import { IPartnerInfo, PartnerTier, PartnerTierType } from "@iloq/shared/IPartnerInfo";
import { ReactNode, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { ILoqLogoSmall } from "./iloq-logo-small";

const SHOW_TEMPORARY_TAG = true;

export function PartnerOverlay({
  partnerInfo,
  tier,
}: {
  partnerInfo: IPartnerInfo;
  tier: PartnerTierType;
}): ReactNode {
  const { svg, color, text } = useMemo(() => {
    let color = "white";
    if (tier === PartnerTier.PLATINUM) {
      color = "#1A1B31";
    }
    if (tier === PartnerTier.GOLD) {
      color = "#D1C3AB";
    }

    return {
      svg: <ILoqLogoSmall color={color} />,
      color,
      text: (
        <Text
          textTransform="uppercase"
          fontWeight="bold"
          fontSize="16px"
          lineHeight="16px"
          justifySelf="flex-end"
          noOfLines={1}
        >
          <FormattedMessage id={`partnerProgram.frontpage.${tier}`} />{" "}
          <FormattedMessage id="partnerProgram.frontpage.partner" />
        </Text>
      ),
    };
  }, [tier]);

  if (SHOW_TEMPORARY_TAG) {
    return (
      <Flex
        py="8px"
        px="16px"
        color={color}
        gap="2"
        alignItems="center"
        borderRadius="32px"
        border={`1px solid`}
      >
        {svg}
        {text}
      </Flex>
    );
  }

  // TODO: Enable popover in a later phase
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          py="8px"
          px="16px"
          color={color}
          gap="2"
          alignItems="center"
          borderRadius="32px"
          border={`1px solid`}
        >
          {svg}
          {text}
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverBody
            as={Card}
            display="flex"
            flexDir="column"
            gap="8"
            alignItems="center"
            padding="xl"
          >
            <Text fontSize="lg" fontWeight="bold">
              {partnerInfo.partnerName}
            </Text>
            <Box
              as="hr"
              width="46px"
              borderTop={`3px solid ${useToken("colors", "brand.blueLightest")}`}
            />
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
